<template>
    <section class="section">
        <h3 class="title is-3">Объем знаний</h3>
        <b-table
            :data="positions"

            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :loading="isPositionsLoading"

            paginated
            striped
            narrowed
            hoverable
            focusable

            default-sort="title"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >

            <b-table-column field="name" label="Должность"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Поиск..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    <span :title=" props.row.fullname">{{ props.row.fullname }}</span>
                </template>
            </b-table-column>
            <b-table-column field="code" label="Код"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Поиск..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.code }}
                </template>
            </b-table-column>

            <b-table-column field="action" label="" v-slot="props" width="100px">
                <div class="buttons" v-if="true || props.row.status === STATUS_IN_REVIEW">
                    <b-button title="Подтвердить" @click="openEdit(props.row.id)" icon-left="pencil" type="is-success" size="is-small" />
                </div>
            </b-table-column>

            <template #empty>
                <div class="has-text-centered">Нет должностей...</div>
            </template>
        </b-table>
    </section>
</template>
<script>


import { mapActions, mapGetters } from 'vuex'
import { assign, pick, get, find, each } from 'lodash'
import { STATUS_APPROVED, STATUS_DECLINED, STATUS_IN_REVIEW } from '../../../store/models/applications/model'

export default {
    computed: {
        ...mapGetters({
            positionQuery: 'e/positions/query',
            isLoaderActive: 'e/pages/isLoaderActive',

        }),

        positions() {
            return this.positionQuery().orderBy('name').where('parentId', value => !!value).get()
        },
        isPositionsLoading() {
            return this.isLoaderActive('positions.fetchItems')
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        ...mapActions({
            fetchPositions: 'e/positions/fetchItems',
        }),
        fetch() {
            this.fetchPositions({page: this.currentPage, perPage: this.perPage}).then((data)=>{
                this.total = get(data, 'meta.total', 0)
            })
        },
        openEdit(id) {
            this.$router.push({name: 'knowledges.show', params: {id}})
        }
    },
    data() {
        return {
            selected: null,
            currentPage: 1,
            perPage: 50,
            total: 0,
        }
    },
    watch: {
        currentPage() {
            this.fetch()
        },
    }
}
</script>